import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { t } from "i18next";
import { Col, Row } from "react-bootstrap";
import PageHeader from "../../../Layouts/PageHeader/PageHeader";
import styles from "./Dashboard.module.scss";
import ReportFilterRaceSummary from "../Report/ReportFilterRaceSummary";
import ReportFilterDailySummary from "../Report/ReportFilterDailySummary";
import ReportFilterMonthlySummary from "../Report/ReportFilterMonthlySummary";
import ReportFilterCustomSummary from "../Report/ReportFilterCustomSummary";
import ReportFilterPortDues from "../Report/ReportFilterPortDues";
import ReportFilterTrips from "../Report/ReportFilterTrips";
import ReportTicketSummary from "../Report/ReportTicketSummary";




import { ToastContainer } from "react-toastify";

function Dashboard(props) {
    const [key, setKey] = useState('race');

    React.useEffect(() => {

        console.log("TabReport")
        console.log(props)
        console.log("TabReport")


    }, []);

    return (
        <div className={styles.Dashboard}>
            <>
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    closeOnClick
                    newestOnTop={true}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ "zIndex": 1000000 }}
                >
                </ToastContainer>
            </>
            <div>
                <PageHeader titles={t("title_dashboard")} />
                <Row>
                    <Col xl={12}>
                        <Tabs
                            id="controlled-tab-report"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="race" title={t("Riepilogo Corsa")}>
                                <ReportFilterRaceSummary {...props} />
                            </Tab>

                            <Tab eventKey="daily" title={t("Riepilogo Giornaliero")}>
                                <ReportFilterDailySummary {...props} />
                            </Tab>
                            <Tab eventKey="monthly" title={t("Riepilogo Mensile")}>
                                <ReportFilterMonthlySummary {...props} />
                            </Tab>
                            <Tab eventKey="custom" title={t("Riepilogo Personalizzato")}>
                                <ReportFilterCustomSummary {...props} />
                            </Tab>

                            {/*<Tab eventKey="port" title={t("Riepilogo Diritti Portuali")}>
                                <ReportFilterPortDues {...props} />
                            </Tab>*/}
                            <Tab eventKey="trips" title={t("Riepilogo Itinerario")}>
                                <ReportFilterTrips {...props} />
                            </Tab>
                            {/*<Tab eventKey="ticket_summary" title={t("ticket_summary")}>
                                <ReportTicketSummary {...props} />
                            </Tab>*/}
                        </Tabs>
                    </Col>
                </Row>
            </div>
        </div>
    )

}

export default Dashboard;

/*



 */
